import React from "react";
import { FaCode, FaCoffee } from "react-icons/fa";


function Footer() {
  return (
    <div class=" flex flex-col gap-1 text-xl px-4 justify-center text-gray-500 items-center">
        <div>Powered by</div>
       <div className="flex gap-4">         
        <FaCode />
        <FaCoffee  />
       </div>
   
</div>
  );
}

export default Footer;